/**
 * IAB US Privacy ("USP") string values used by the __uspapi stub.
 *
 * Format: [version][notice given][opt-out of sale][LSPA covered transaction].
 * The site is not an LSPA signatory, so the 4th char is always 'N' (not '-';
 * '-' means "not applicable" and is reserved for the fully-inapplicable case).
 */
export const USP_STRINGS = {
	/** Notice given + opted out of sale/sharing (GPC active). */
	OPT_OUT: '1YYN',
	/** Notice given, explicit no opt-out. */
	NO_OPT_OUT: '1YNN',
	/** Not a CCPA region, or geo not yet resolved. */
	NOT_APPLICABLE: '1---',
} as const;

export const GPC_TOAST = {
	/** How long the confirmation toast stays visible (ms). */
	AUTO_HIDE_MS: 5000,
};

export const SESSION_FLAG = 'gpc_notice_shown';